import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-simpler-select'
import ReactTooltip from 'react-tooltip'

import NumberInput from './UI/NumberInput'
import Button from './UI/Button'

import tooltips from '../constants/tooltips.json'

import {
  selectPedal,
  setPedalMode,
  setPedalCC,
  setPedalChannel
} from '../actions/'

const pedalModeOptions = [
  { label: 'Internal Sustain', value: 0},
  { label: 'CC', value: 1},
  { label: 'Both', value: 2}
]

class Pedals extends Component {
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  render() {
    const {
      pedals,
      selectedPedal,
      onSelectPedal,
      onSelectPedalCC,
      onSelectPedalMode,
      onSelectPedalChannel,
      showTooltips
    } = this.props

    const currentPedal = pedals[selectedPedal]

    return (
      <div className="pedals">
        <h2
          data-tip={tooltips["editor-pedals"]}
          data-multiline="true"
          data-place="top"
          data-tip-disable={!showTooltips}
        >
          Pedals
        </h2>
        <div
          className="pedal-buttons"
          data-tip={tooltips["editor-pedal-select"]}
          data-multiline="true"
          data-place="left"
          data-tip-disable={!showTooltips}
        >
          <Button
            name="pedal-1-button"
            kind="square"
            index={0}
            value={0}
            toggle={selectedPedal}
            onClick={onSelectPedal}
          />
          <span className="pedal-1-label">Sustain</span>
          <Button
            name="pedal-2-button"
            kind="square"
            index={1}
            value={1}
            toggle={selectedPedal}
            onClick={onSelectPedal}
          />
          <span className="pedal-2-label">Switch</span>
          <Button
            name="pedal-3-button"
            kind="square"
            index={2}
            value={2}
            toggle={selectedPedal}
            onClick={onSelectPedal}
          />
          <span className="pedal-3-label">Expression</span>
        </div>

        <div className="pedal-options-grid">
          {currentPedal.mode !== 0 && (
            <label
              className="pedal-cc"
              data-tip={tooltips["editor-pedal-cc"]}
              data-multiline="true"
              data-place="left"
              data-tip-disable={!showTooltips}
            >
              CC
              <NumberInput
                name="pedalCC"
                min={0}
                max={127}
                step={1}
                value={currentPedal.cc}
                onChange={(value) => {
                  onSelectPedalCC(selectedPedal, value);
                }}
              />
            </label>
          )}
          <label
            className="pedal-mode"
            data-tip={tooltips["editor-pedal-mode"]}
            data-multiline="true"
            data-place="left"
            data-tip-disable={!showTooltips}
          >
            Pedal Mode
            <Select
              name="pedalMode"
              value={currentPedal.mode}
              options={pedalModeOptions}
              disabled={selectedPedal === 2 ? "disabled" : ""}
              onChange={(value) => onSelectPedalMode(selectedPedal, value)}
            />
          </label>
          <label
            className="pedal-channel"
            data-tip={tooltips["editor-pedal-channel"]}
            data-multiline="true"
            data-place="left"
            data-tip-disable={!showTooltips}
          >
            Channel
            <NumberInput
              name="pedalChannel"
              value={currentPedal.channel + 1}
              min={1}
              max={16}
              step={1}
              onChange={(value) => onSelectPedalChannel(selectedPedal, value)}
            />
          </label>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedPedal: state.editor.selectedPedal,
    pedals: state.currentPreset.pedals,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectPedal: (target) => {
      dispatch(selectPedal(~~target.value))
    },
    onSelectPedalMode: (index, value) => {
      dispatch(setPedalMode(index, ~~value))
    },
    onSelectPedalCC: (index, value) => {
      dispatch(setPedalCC(index, ~~value))
    },
    onSelectPedalChannel: (index, value) => {
      dispatch(setPedalChannel(index, ~~value - 1))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pedals)
